<template>
    <div>
        <div v-show="passed_filter_left">
                <designer-question-select-frame-sidepanel :fabricator="fabricator"
                                                          :door-range="doorRange"
                                                          :frame-material="frameMaterial"
                                                          :frame-style-id="frame_id"
                                                          v-model:target="target.left"
                                                          :frame-colour-external="frameColourExternal"
                                                          :frame-colour-internal="frameColourInternal"
                                                          :title="'Select Left Side Panel Style'"
                                                          :measurement.sync="measurements.left_width"
                                                          measurement-key="left_width"
                                                          measurement-label="Enter your Left Width"
                                                          :component_id="'left_side_panel_style'"
                                                         :panel-category="panelCategory"
                ></designer-question-select-frame-sidepanel>

                <div v-if="passed_filter_left_comp">
                    <designer-question-select-comp-options :fabricator="fabricator"
                                                           v-model:target="target.left_composite_id"
                                                           :door-range="doorRange"
                                                           :title="'Select Left Side Panel Composite Style'"
                                                           :component_id="'left_side_panel_composite_style'"
                    ></designer-question-select-comp-options>

                    <div v-if="passed_filter_left_comp_glass">
                        <designer-question-select-comp-glass :fabricator="fabricator"
                                                             v-model:target="target.left_composite_glass_id"
                                                             :comp-slab="target.left_composite_id"
                                                             :laminated-glass="laminatedGlass"
                                                             :title="'Select Left Side Panel Composite Glass'"
                                                             :component_id="'left_side_panel_composite_glass'"
                        ></designer-question-select-comp-glass>

                        <designer-question-glass-backing-design :fabricator="fabricator"
                                                                v-model:target="target.left_composite_backing_glass_id"
                                                                :slab="target.left_composite_id"
                                                                :glass-design="target.left_composite_glass_id"
                                                                :component_id="'left_side_panel_composite_backing_glass'"
                        ></designer-question-glass-backing-design>

                    </div>
                </div>

                <div v-show="passed_filter_left_glass">
                    <designer-question-select-side-glass :fabricator="fabricator"
                                                         v-model:target="target.left_panel_glass_id"
                                                         :frame-combination="frame_id"
                                                         :secured-by-design="securedByDesign"
                                                         :side-variant="target.left"
                                                         :title="'Select Left Side Panel Glass'"
                                                         :component_id="'left_side_panel_glass'"
                                                         :slab="slab"
                                                         :type-range="doorRange"
                                                         :panel-category="panelCategory"
                    ></designer-question-select-side-glass>

                    <designer-question-select-side-glass-obscure :fabricator="fabricator"
                                                                 v-model:target="target.left_panel_backing_glass_id"
                                                                 :panel-glass-id="target.left_panel_glass_id"
                                                                 :title="'Select Left Side Panel Backing Glass'"
                                                                 :component_id="'left_side_panel_backing_glass'"
                    ></designer-question-select-side-glass-obscure>
                </div>
        </div>
        <div v-show="passed_filter_right">
                <designer-question-select-frame-sidepanel :fabricator="fabricator"
                                                          :door-range="doorRange"
                                                          v-model:target="target.right"
                                                          :frame-material="frameMaterial"
                                                          :frame-style-id="frame_id"
                                                          :frame-colour-external="frameColourExternal"
                                                          :frame-colour-internal="frameColourInternal"
                                                          :title="'Select Right Side Panel Style'"
                                                          :measurement.sync="measurements.right_width"
                                                          measurement-key="right_width"
                                                          measurement-label="Enter your Right Width"
                                                          :component_id="'right_side_panel_style'"
                                                         :panel-category="panelCategory"
                ></designer-question-select-frame-sidepanel>

                <div v-if="passed_filter_right_comp">
                    <designer-question-select-comp-options :fabricator="fabricator"
                                                           v-model:target="target.right_composite_id"
                                                           :door-range="doorRange"
                                                           :title="'Select Right Side Panel Composite Style'"
                                                           :component_id="'right_side_panel_composite_style'"
                    ></designer-question-select-comp-options>

                    <div v-if="passed_filter_right_comp_glass">
                        <designer-question-select-comp-glass :fabricator="fabricator"
                                                             v-model:target="target.right_composite_glass_id"
                                                             :comp-slab="target.right_composite_id"
                                                             :laminated-glass="laminatedGlass"
                                                             :title="'Select Right Side Panel Composite Glass'"
                                                             :component_id="'right_side_panel_composite_glass'"
                        ></designer-question-select-comp-glass>

                        <designer-question-glass-backing-design :fabricator="fabricator"
                                                                v-model:target="target.right_composite_backing_glass_id"
                                                                :slab="target.right_composite_id"
                                                                :glass-design="target.right_composite_glass_id"
                                                                :component_id="'right_side_panel_composite_backing_glass'"
                        ></designer-question-glass-backing-design>
                    </div>
                </div>

            <div v-show="passed_filter_right_glass">
                <designer-question-select-side-glass :fabricator="fabricator"
                                                     v-model:target="target.right_panel_glass_id"
                                                     :frame-combination="frame_id"
                                                     :secured-by-design="securedByDesign"
                                                     :side-variant="target.right"
                                                     :slab="slab"
                                                     :type-range="doorRange"
                                                     :title="'Select Right Side Panel Glass'"
                                                     :component_id="'right_side_panel_glass'"
                                                     :panel-category="panelCategory"
                ></designer-question-select-side-glass>

                <designer-question-select-side-glass-obscure :fabricator="fabricator"
                                                             v-model:target="target.right_panel_backing_glass_id"
                                                             :panel-glass-id="target.right_panel_glass_id"
                                                             :title="'Select Right Side Panel Backing Glass'"
                                                             :component_id="'right_side_panel_backing_glass'"
                ></designer-question-select-side-glass-obscure>
            </div>

        </div>
        <div v-show="passed_filter_top_glass">

          <designer-question-select-frame-sidepanel-top :fabricator="fabricator"
                                                        :door-range="doorRange"
                                                        :frame-material="frameMaterial"
                                                        :frame-combination="frameStyle.frame_id"
                                                        v-model:target="target.top"
                                                        :frame-style-id="frame_id"
                                                        :frame-colour-external="frameColourExternal"
                                                        :frame-colour-internal="frameColourInternal"
                                                        :title="'Select Top Panel Style'"
                                                        :component_id="'top_panel_style'"
          ></designer-question-select-frame-sidepanel-top>

                <designer-question-select-side-glass :fabricator="fabricator"
                                                     v-model:target="target.top_panel_glass_id"
                                                     :frame-combination="frame_id"
                                                     :secured-by-design="securedByDesign"
                                                     :side-variant="0"
                                                     :slab="slab"
                                                     :type-range="doorRange"
                                                     :title="'Select Top Panel Glass'"
                                                     :component_id="'top_panel_glass'"
                                                     :panel-category="panelCategory"
                ></designer-question-select-side-glass>

                <designer-question-select-side-glass-obscure :fabricator="fabricator"
                                                             v-model:target="target.top_panel_backing_glass_id"
                                                             :panel-glass-id="target.top_panel_glass_id"
                                                             :title="'Select Top Panel Backing Glass'"
                                                             :component_id="'top_panel_backing_glass'"
                ></designer-question-select-side-glass-obscure>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            measurements: {
                required: true,
            },
            target: {
                required: true,
                coerce(val) {
                    if (typeof (val) !== 'object') {
                        return {
                            left_composite_id: 0,
                            right_composite_id: 0
                        };
                    }

                    return val;
                }
            },
            frameStyle: {
                type: Object,
                required: true,
            },
            laminatedGlass: {
                required: true,
            },
            frameMaterial: {
                required: true,
            },
            panelCategory: {
                required: false,
                default(){
                    return 0;
                }
            },
            title: {
                default(){
                    return 'Select Side Panel Style';
                }
            },
            frameColourInternal: {
                required: true,
            },
            frameColourExternal: {
                required: true,
            },
            doorRange: {
                required: true,
            },
            securedByDesign: {
                required: true,
            },
            slab: {
              required: true,
            },
            mirrorSidepanels: {
                default(){
                    return false;
                }
            },
        },
        computed: {
            frame_id(){
                return this.frameStyle.frame_id;
            },
            passed_filter_left(){
                return this.frameStyle.checkedPanels.indexOf("left") !== -1;
            },
            passed_filter_right(){
                return this.frameStyle.checkedPanels.indexOf("right") !== -1;
            },
            passed_filter_top_glass(){
                return this.frameStyle.checkedPanels.indexOf("top") !== -1;
            },
            passed_filter_left_comp(){
                return this.localTarget.left === 3 || this.localTarget.left === 9 || this.localTarget.left === 17 || this.localTarget.left === 26 || this.localTarget.left === 43 || this.localTarget.left === 44;
            },
            passed_filter_right_comp(){
                return this.localTarget.right === 3 || this.localTarget.right === 9 || this.localTarget.right === 17 || this.localTarget.right === 26 || this.localTarget.right === 43 || this.localTarget.right === 44;
            },
            passed_filter_left_comp_glass(){
                return this.localTarget.left_composite_id > 0;
            },
            passed_filter_right_comp_glass(){
                return this.localTarget.right_composite_id > 0;
            },
            show_right_comp_glass_options(){
                if(this.fabricator === 5) {
                    return !this.passed_filter_left && this.passed_filter_right_comp_glass;
                }
                return this.passed_filter_right_comp_glass;
            },
            passed_filter_left_glass(){
                return (this.localTarget.left !== 3 && this.localTarget.left !== 9 && this.localTarget.left !== 17 && this.localTarget.left !== 26 && this.localTarget.left !== 43 && this.localTarget.left !== 44);
            },
            passed_filter_right_glass(){
                return (this.localTarget.right !== 3 && this.localTarget.right !== 9 && this.localTarget.right !== 17 && this.localTarget.right !== 26 && this.localTarget.right !== 43 && this.localTarget.right !== 44);
            },
            thumbURL(){
                return '/thumb/sidepanel/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/side-panel?frame_colour_external=' + this.frameColourExternal + '&frame_colour_internal=' + this.frameColourInternal + '&framematerial=' + this.frameMaterial + '&frame_id=' + this.frame_id;
            },
            cache_key(){
                return '_' + this.fabricator;
            },
        },
        methods: {
            select_first(){
// we don't need this function so block off parent
            },
            mirrorSidePanelSelections() {
                if(this.mirrorSidepanels) {
                    const checkedPanels = this.frameStyle.checkedPanels;

                    if (!checkedPanels.includes('left') && !checkedPanels.includes('right')) {
                        return;
                    }

                    const sourceSide = checkedPanels.includes('left') ? 'left' : 'right';
                    const targetSide = sourceSide === 'left' ? 'right' : 'left';
                    const mirroredPropertySuffixes = [
                        '',
                        '_composite_id',
                        '_composite_glass_id',
                        '_composite_backing_glass_id',
                        '_panel_glass_id',
                        '_panel_backing_glass_id',
                    ];

                    mirroredPropertySuffixes.forEach((suffix) => {
                        const sourceProperty = sourceSide + suffix;
                        const targetProperty = targetSide + suffix;

                        if (this.target[targetProperty] !== this.target[sourceProperty]) {
                            this.target[targetProperty] = this.target[sourceProperty];
                        }
                    });
                }
            },
        },
        watch: {
            target: {
                handler() {
                    this.mirrorSidePanelSelections();
                },
                deep: true,
            },
            'frameStyle.checkedPanels': {
                handler() {
                    this.mirrorSidePanelSelections();
                },
                deep: true,
            },
        }
    }
</script>
